var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFadedMobileParticles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 55,
    viewBox: "0 0 66 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2857 34.3404C43.9122 34.3404 46.0415 32.0612 46.0415 29.2497C46.0415 26.4381 43.9122 24.1589 41.2857 24.1589C38.6591 24.1589 36.5298 26.4381 36.5298 29.2497C36.5298 32.0612 38.6591 34.3404 41.2857 34.3404Z",
    fill: "url(#paint0_linear_289_29703)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7793 44.6663C52.5647 44.8768 52.4164 45.2865 52.4051 45.7002C52.3991 45.9179 52.6791 52.9911 52.7041 53.253C52.798 54.2397 53.393 54.6854 54.2249 54.3924L54.4042 54.3293L57.4783 52.2376L60.5524 50.146L60.6648 50.0198C61.2636 49.347 61.1566 48.6064 60.3839 48.0771C60.2115 47.9591 54.3308 44.6743 54.0922 44.5628C53.5775 44.3223 53.0908 44.3607 52.7793 44.6663Z",
    fill: "url(#paint1_linear_289_29703)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0623 19.2512C25.5472 18.7544 25.0305 18.6439 24.4154 18.8988C24.2564 18.9647 24.0466 19.1353 20.9128 21.7477L17.5794 24.5265L14.9425 20.9329C12.0147 16.9429 12.2516 17.2405 11.8279 17.0202C10.8572 16.5156 9.34107 17.6551 9.40822 18.8389C9.44184 19.4334 9.41062 19.3848 12.3507 23.4087L14.842 26.8182L11.4269 29.6894C8.21593 32.3888 8.00545 32.5699 7.90614 32.7202C7.45225 33.4073 7.47735 34.0562 7.98748 34.8211C8.55823 35.6766 9.20457 35.9382 9.97251 35.6242L10.1864 35.5368L13.6113 32.6807L17.0362 29.8246L19.6549 33.3936L22.2737 36.9626L22.465 37.1124C23.1216 37.6263 23.7022 37.5866 24.4332 36.9779C25.1729 36.362 25.3668 35.8061 25.1181 35.0133L25.0404 34.7653L22.4078 31.1484L19.7753 27.5315L23.0866 24.748L26.3979 21.9644L26.5288 21.7633C27.0312 20.9907 26.8491 20.0101 26.0623 19.2512Z",
    fill: "url(#paint2_linear_289_29703)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3535 5.36232C36.3422 5.36368 36.3026 5.36785 36.2655 5.37158C34.659 5.53284 33.5838 7.2736 34.0613 8.94044C34.4473 10.2879 35.7508 11.1125 37.0486 10.8303C38.0577 10.6108 38.8571 9.75508 39.0603 8.67675C39.3604 7.08417 38.3344 5.56956 36.8228 5.37372C36.7482 5.36405 36.4076 5.35578 36.3535 5.36232ZM36.6887 6.3947C37.9435 6.52814 38.5801 8.08503 37.8219 9.16598C37.1104 10.1804 35.6383 10.0492 35.0922 8.92274C34.502 7.70529 35.4151 6.25925 36.6887 6.3947Z",
    fill: "url(#paint3_linear_289_29703)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4377 8.16339C46.8826 8.95018 46.693 10.0148 46.9021 11.1706C46.9981 11.7006 49.8134 23.1363 49.9561 23.5753C50.7235 25.9369 52.7389 26.7661 54.6715 25.5154L55.0143 25.2935L59.4794 20.5577L63.9446 15.8219L64.1467 15.4692C65.3165 13.4279 64.5659 11.2686 62.3934 10.426C62.013 10.2784 51.1744 7.11178 50.7381 7.02073C49.6883 6.80166 48.6993 7.0063 47.9694 7.59368C47.8026 7.72791 47.6625 7.84335 47.6581 7.85009C47.6536 7.85695 47.5544 7.99793 47.4377 8.16339ZM49.7289 9.69797C50.0307 9.64097 49.837 9.58874 55.9154 11.3662C62.1351 13.185 61.7659 13.0664 62.0028 13.3223C62.1765 13.51 62.1641 13.6699 61.9482 14.0246C61.7713 14.3154 53.5086 23.0619 53.2874 23.1927C52.8182 23.4699 52.598 23.3352 52.3885 22.6432C52.2903 22.3186 49.4893 10.8873 49.4442 10.6268C49.3392 10.0205 49.4202 9.75636 49.7289 9.69797Z",
    fill: "url(#paint4_linear_289_29703)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_289_29703",
    x1: 36.5298,
    y1: 29.2497,
    x2: 46.0415,
    y2: 29.2497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF832A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_289_29703",
    x1: 51.2075,
    y1: 51.1114,
    x2: 59.4734,
    y2: 46.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF832A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_289_29703",
    x1: 10.0435,
    y1: 17.4474,
    x2: 25.5862,
    y2: 36.0126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF832A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_289_29703",
    x1: 33.9471,
    y1: 8.12276,
    x2: 39.1125,
    y2: 8.12276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF832A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_289_29703",
    x1: 47.0745,
    y1: 21.0917,
    x2: 60.9469,
    y2: 8.25083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF832A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFadedMobileParticles);
export default __webpack_public_path__ + "static/media/Faded_Mobile_Particles.584a00693a602e9c4be59187ac75767f.svg";
export { ForwardRef as ReactComponent };